import React from 'react';
import Icon from '../AppIcon';

const Footer = () => {
  return (
    <footer className="border-t border-border bg-card mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-6 gap-x-6 xl:gap-x-10 mb-6">
          {/* Company Info */}
          <div className="min-w-0">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
                <Icon name="Zap" size={20} color="white" />
              </div>
              <span className="text-lg font-semibold text-foreground">JobAspirant</span>
            </div>
            <p className="text-sm text-muted-foreground mb-4">
              Transform careers through innovative technology solutions.
            </p>

            {/* Social Media Links */}
            <div className="flex items-center space-x-3">
              <a
                href="https://www.instagram.com/qubitly_edu/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-foreground transition-colors"
                aria-label="Follow us on Instagram"
              >
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Company */}
          <div className="min-w-0">
            <h4 className="text-sm font-semibold text-foreground mb-4">Company</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <a
                  href="https://qubitlyventures.com/en/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-foreground transition-colors"
                >
                  About
                </a>
              </li>
              <li>
                <button
                  onClick={() => {
                    const ok = window.confirm('You are about to leave JobAspirant and go to Qubitly Ventures (Careers). Continue?');
                    if (ok) window.open('https://qubitlyventures.com/en/careers/', '_blank', 'noopener,noreferrer');
                  }}
                  className="hover:text-foreground transition-colors text-left"
                >
                  Careers
                </button>
              </li>
            </ul>
          </div>

          {/* Our other Platforms */}
          <div className="min-w-0">
            <h4 className="text-sm font-semibold text-foreground mb-4">Our other Platforms</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <button
                  onClick={() => {
                    const ok = window.confirm('You are about to leave JobAspirant and go to AIBrahmi. Continue?');
                    if (ok) window.open('https://aibrahmi.com/', '_blank', 'noopener,noreferrer');
                  }}
                  className="hover:text-foreground transition-colors text-left"
                >
                  AIBrahmi
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    const ok = window.confirm('You are about to leave JobAspirant and go to r/CareerSupportIndia. Continue?');
                    if (ok) window.open('https://www.reddit.com/r/CareerSupportIndia/', '_blank', 'noopener,noreferrer');
                  }}
                  className="hover:text-foreground transition-colors text-left"
                >
                  CareerSupportIndia (Reddit)
                </button>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div className="min-w-0">
            <h4 className="text-sm font-semibold text-foreground mb-4">Resources</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <a href="/blog" className="hover:text-foreground transition-colors">
                  Blog
                </a>
              </li>
              <li>
                <a href="/privacy-policy" className="hover:text-foreground transition-colors">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="/cookie-policy" className="hover:text-foreground transition-colors">
                  Cookie Policy
                </a>
              </li>
              <li>
                <a href="/terms-of-service" className="hover:text-foreground transition-colors">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-border pt-6">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between space-y-4 md:space-y-0">
            <div className="flex flex-col md:flex-row items-start md:items-center space-y-4 md:space-y-0 md:space-x-4">
              <img
                src="/logo/QubitlyLogo.webp"
                alt="Qubitly Ventures"
                className="h-12 md:h-16 w-auto object-contain"
              />
              <div className="text-xs text-muted-foreground space-y-1">
                <div>All trademarks are the property of their respective owners</div>
                <div>All rights reserved © 2026 Qubitly Ventures LLP</div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;